module.exports = __webpack_public_path__ + "static/media/image (22).986d0672.jpg";